import { MeditationRetreatsTable } from "@/components/MeditationRetreats";
import { TableTitles } from "@/constants";
import { useGetMeditationRetreats } from "@/hooks/query-hooks/useMeditationRetreats";
import { cn } from "@/libs/cn";
import { Button, DatePicker, Divider, Flex, Space } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { Helmet } from 'react-helmet-async';
import { AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router";
import { AnimatedComponent, PageTitle } from "../common";

export function AttendanceMeditationRetreatList({
	Component,
}: {
	Component?: React.FC;
}) {
	const [currentYear, setCurrentYear] = useState(dayjs().year());
	const [page, setPage] = useState(1);

	const { data, isLoading, isFetching } = useGetMeditationRetreats(
		page,
		currentYear,
	);

	const retreats = data?.content ?? [];

	const onYearChange = (date: dayjs.Dayjs | null) => {
		if (date) {
			setCurrentYear(date.year());
		}
	};

	const renderColumnsKey = [
		TableTitles.retreat_start_month,
		TableTitles.retreat_level,
		TableTitles.retreat_name,
		TableTitles.retreat_end_date,
		TableTitles.retreat_start_date,
		TableTitles.retreat_status,
		TableTitles.retreat_attendance,
		TableTitles.action,
	];

	return (
		<AnimatedComponent>
			<Helmet>
				<title>တရားစခန်းများ</title>
				<meta
					name="description"
					content="လစဉ်အလိုက်ကျင်းပမည့် တရားစခန်းများ"
				/>
			</Helmet>
			<Flex justify="space-between" align="center" gap={12}>
				<PageTitle
					className={cn({
						"text-base": Component, // base font size for Dashboard & Pages with Component prop
					})}
				>
					တရားစခန်းများ
				</PageTitle>
			</Flex>
			<Divider />
			<div className="!space-y-4">
				<DatePicker.YearPicker
					size="large"
					defaultValue={dayjs()}
					onChange={onYearChange}
					allowClear={false}
					inputReadOnly
					className="w-24 !rounded-md"
				/>
				<MeditationRetreatsTable
					dataSource={retreats}
					renderColumnKeys={renderColumnsKey}
					TableActionComponent={TableActionComponent}
					loading={isLoading || isFetching}
					pagination={{
						current: page,
						onChange: (page) => setPage(page),
						total: data?.totalElements,
						pageSize: data?.size,
					}}
				/>
			</div>
		</AnimatedComponent>
	);
}

const TableActionComponent = ({ record }: { record: MeditationRetreat }) => {
	return (
		<Space>
			<Link to={`${record.id}/detail`}>
				<Button icon={<AiOutlineEye size={18} />} type="link" />
			</Link>
		</Space>
	);
};
